// api/breaches.ts
import apiInstance from "shared/api/axiosConfig";

export async function getClientBreaches(userType: string = 'individual') {
    try {
        const response = await apiInstance.post("/client/breaches",
          {
              type: userType
          },
        );
        return response.data;
    } catch (e) {
        console.error('Erreur getClientBreaches:', e);
        throw e;
    }
}

export async function checkNewDataBreach(userType: string = 'individual') {
    try {
        const response = await apiInstance.post("/client/breaches/check",
          {
              type: userType,
          },
        );
        return response.data;
    } catch (e) {
        console.error('Erreur checkNewDataBreach:', e);
        throw e;
    }
}

export async function getBreachesByEmail(email: string) {
  try {
    const response = await apiInstance.post("/client/breaches/getByEmail",
      {
        email
      },
    );
    return response.data;
  } catch (e) {
    console.error('Erreur getClientBreaches:', e);
    throw e;
  }
}